// components/Loader.js
import React from 'react';
import '../styles/Loader.css'; // Create a separate CSS file for loader styles

const Loader = () => {
  return (
    <div className="loading-container">
      <img src="/luffyLoading.gif" alt="Loading" />
      <h4>Loading...</h4>
    </div>
  );
};

export default Loader;
